/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import React from "react";
import { AutocompleteRenderInputParams, CircularProgress, TextField, TextFieldProps } from "@mui/material";
import ErrorText from "../../../ErrorText";

const SUCHBEGRIFF_MAX_LENGTH = 250;

type AutocompleteRenderInputProps =
    & AutocompleteRenderInputParams
    & {
        caption: TextFieldProps["label"],
        loading: boolean,
        errors?: string[],
        required?: TextFieldProps["required"],
        autoFocus?: TextFieldProps["autoFocus"],
        placeholder?: TextFieldProps["placeholder"],
        error?: TextFieldProps["error"],
    }

// Das SCSS des AutocompleteRenderInput muss in der App importiert werden
export default function AutocompleteRenderInput(props: AutocompleteRenderInputProps) {
    const { caption, loading, errors, required, autoFocus, placeholder, error, ...rest } = props;
    return (
        <TextField
            {...rest}
            required={required}
            autoFocus={autoFocus}
            placeholder={placeholder}
            label={caption}
            InputLabelProps={{
                ...props.InputLabelProps,
                shrink: true,
            }}
            inputProps={{
                // max-length muss über den Eingaben stehen, dass es ggf. überschrieben wird
                maxLength: SUCHBEGRIFF_MAX_LENGTH,

                ...props.inputProps,
            }}
            InputProps={{
                ...props.InputProps,
                endAdornment: (
                    <React.Fragment>
                        {loading ? <CircularProgress color="secondary" size={20} /> : null}
                        {props.InputProps?.endAdornment}
                    </React.Fragment>
                ),
            }}
            error={error}
            helperText={<ErrorText errors={errors ?? []} />}
            fullWidth
            margin="dense"
            size="small"
            autoComplete="off"
        />
    );
}
